<template>
  <div class="login_container">
    <div class="login_box">
      <div data-track-text="关闭" aria-label="关闭" style="position: absolute;left: 99%;top: -25px;" @click="onCloseBlur">
        <div class="closes"></div>
      </div>
      <div class="image_box">
        <img v-if="code===undefined||code==='undefined'||code===''" src="../assets/register.png" alt="" style="width: 333px;height: 501px"/>
        <img v-if="code==='haoyi'" src="../assets/regis-two.png" alt="" style="width: 333px;height: 501px"/>
      </div>
      <el-form label-width="0" class="login_form" :model="from" :rules="login_rules" ref="loginRef">
        <div class="header"><h3 style="margin: 0;font-family: Noto Sans S Chinese !important;">用户注册</h3></div>
        <hr style="
        background-color: #1c50a7;
        width:40px;
            border: 1px solid #1c50a7;
            margin-block-end: 1em;
            margin-top: 8px;
            padding: 0;"/>
        <el-form-item prop="username">
          <el-input placeholder="请输入账号：*仅支持英文、数字、下划线" v-model="from.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" type="password" v-model="from.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input autocomplete="off"
                    placeholder="请输入手机号" v-model="from.phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="validate">
          <el-input placeholder="请输入验证码" v-model="from.validate" style="width: 279.8px"
          ></el-input>
          <img style="float: right;width: 133.5px;height: 44px;font-family: Noto Sans S Chinese !important;"
               :src="qrcodeUrl" alt="验证码加载失败..."
               data-track-text="刷新图形验证码"
               aria-label="刷新图形验证码"
               @click="getValicode"/>
        </el-form-item>
        <el-form-item prop="phoneValidate">
          <el-input placeholder="请输入6位验证码" v-model="from.phoneValidate" style="width: 279.8px"
          ></el-input>
          <div class="timeButton" v-show="Verification" data-track-text="机构注册获取动态密码" aria-label="机构注册获取动态密码" @click="handleTimeClick">获取动态密码</div>
          <div class="timeButtonClick" v-show="!Verification">{{timers}}秒后重新获取</div>
        </el-form-item>
        <div style="color: #df2525;font-size: 15px;font-family: Noto Sans S Chinese !important;">{{messages}}</div>
        <el-form-item style="margin-bottom: 0;margin-top: -10px;">
          <div style="float: left;cursor:pointer;font-family: Noto Sans S Chinese !important;">
            <el-checkbox v-model="checked">我已阅读并同意遵守</el-checkbox>
            <span style="color: #1B4FA7;font-family: Noto Sans S Chinese !important;"
                  data-track-text="机构注册查看用户服务协议"
                  aria-label="机构注册查看用户服务协议"
                  @click="openAgreement">《用户服务协议》</span>
          </div>
          <div style="float: right;cursor:pointer;color: #1B4FA7;font-family: Noto Sans S Chinese !important;"
               data-track-text="机构注册返回登录"
               aria-label="机构注册返回登录"
               @click="toLogin">已有账号，立即登录
          </div>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" data-track-text="提交机构注册" aria-label="提交机构注册" @click="submitRegisterFrom()">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    authServiceClient,
    checkPhoneRequest,
    checkUserNameRequest, phoneCodeRequest,
    registerRequest,
    valicodeRequest
  } from '../tools/api/auth-api'

  export default {
    name: "RegisterTwo",
    data() {
      return {
        code: '',
        isLogin: false,
        auth_timer: null,
        timers: 60,
        isSuccess: false,
        Verification: true,
        from: {
          username: "",
          password: "",
          validate: "",
          phoneValidate: "",
          phone: ""
        },
        login_rules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'},
            {validator: this.validateName, trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
          ],
          validate: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
            {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^1[0-9]{10}$/, message: "请输入合法手机号/电话号", trigger: "blur"},
            {validator: this.validatePhone, trigger: 'blur'}
          ],
          phoneValidate: [
            {validator: this.validatePhoneCode, trigger: 'blur'}
          ]
        },
        qrcodeUrl: "",
        messages: '',
        checked: false
      }
    },
    watch: {
      checked(val) {
        if (val) {
          this.messages = "";
        } else {
          this.messages = "请阅读并同意协议";
        }
      }
    },
    created() {
      this.getValicode();
      this.getValicode();
      this.code = this.getUrlParameter(this.$route.fullPath).code;
    },
    methods: {
      getUrlParameter(route) {
        //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
        let url = decodeURIComponent(route).split('?');
        url = url[url.length - 1];
        let obj = {};
        url.split('&').map((query) => {
          let temp = query.split('=');
          obj[temp[0]] = temp[1];
        });
        return obj;
      },
      validatePhoneCode(rule, value, callback) {
        if (!this.isLogin) {
          callback()
          return
        }
        if (value === null || value === undefined || value === "") {
          callback(new Error('请输入手机验证码'))
          return;
        }
        if (value.length > 6 || value.length < 6) {
          callback(new Error('请输入6位手机验证码'))
          return;
        }
        callback()
      },
      handleTimeClick() {
        this.$refs.loginRef.validate((valid) => {
          if (!valid) {
            return;
          }
          const that = this;
          let request = phoneCodeRequest;
          request.setCode(this.from.validate)
          request.setPhone(this.from.phone)
          const CODE_KEY = 'code';
          let metadata;
          if (localStorage.getItem(CODE_KEY)) {
            metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
          } else {
            metadata = {}
          }
          authServiceClient.sendPhoneCode(request, metadata)
            .then(res => {
              if (res.getStatus()) {
                that.messages = "";
                that.Verification = false;
                this.auth_timer = setInterval(() => {
                  that.timers--;
                  if (that.timers <= 0) {
                    that.Verification = true;
                    that.timers = 60;
                    clearInterval(that.auth_timer)
                  }
                }, 1000)
                return;
              }
              that.getValicode();
              that.messages = "验证码错误"
              that.Verification = true;
              that.timers = 60;
            }).catch(err => {
            that.getValicode();
            that.messages = "手机验证码发送失败"
            that.Verification = true;
            that.timers = 60;
          });
        });
      },
      openAgreement() {
        window.open("/agreement");
      },
      onCloseBlur() {
        parent.window.location.reload();
      },
      validatePhone(rule, value, callback) {
        let request = checkPhoneRequest;
        request.setPhone(value);
        authServiceClient.checkPhone(request, null).then(res => {
          if (res.getStatus() === 3) {
            callback();
            return;
          }
          callback(new Error('手机号已注册'))
        }).catch(err => {
          callback(new Error('校验出错'));
        })
      },
      validateName(rule, value, callback) {
        if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
          callback(new Error('用户名不能含有汉字'));
          return;
        }
        if (/.*[`~!#$^&*()=|{}':;',\[\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]+.*$/.test(value)) {
          callback(new Error('用户名不能包含特殊字符'));
          return;
        }
        let request = checkUserNameRequest;
        request.setUsername(value);
        authServiceClient.checkUserName(request, null).then(res => {
          if (res.getStatus() === 3) {
            callback();
            return;
          }
          callback(new Error('用户名已注册'))
        }).catch(err => {
          callback(new Error('校验出错'));
        })
      },
      toLogin() {
        this.$router.push("/loginTwo?code="+this.code)
      },
      getValicode() {
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
          this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
        })
      },
      submitRegisterFrom() {
        const that = this;
        this.isLogin = true;
        this.$refs.loginRef.validate((valid) => {
          if (!valid) {
            this.isLogin = false;
            return false;
          }
          if (!that.checked) {
            that.messages = "请阅读并同意协议";
            this.isLogin = false;
            return false;
          }
          let request = registerRequest;
          request.setUsername(that.from.username);
          request.setPassword(that.from.password);
          request.setValicode(that.from.validate);
          request.setPhone(that.from.phone + "");
          request.setPhonecode(that.from.phoneValidate);
          const TOKEN_KEY = 'token';
          const CODE_KEY = 'code';
          let metadata;
          if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
            metadata = {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              [CODE_KEY]: localStorage.getItem(CODE_KEY)
            }
          } else if (localStorage.getItem(TOKEN_KEY) && !localStorage.getItem(CODE_KEY)) {
            metadata = {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY)
            }
          } else if (!localStorage.getItem(TOKEN_KEY) && localStorage.getItem(CODE_KEY)) {
            metadata = {
              [CODE_KEY]: localStorage.getItem(CODE_KEY)
            }
          } else {
            metadata = {}
          }
          authServiceClient.userRegister(request, metadata).then(res => {
            if (res.getStatus() === 0) {
              that.$message({
                center: true,
                type: 'success',
                duration: 3000,
                message: res.getMessage()
              });
              that.$router.push("/loginTwo");
              return;
            }
            this.isLogin = false;
            that.messages = res.getMessage();
            this.getValicode();
          }).catch(err => {
            if (err && err.code === 5) {
              this.$router.push("/registerTwo")
            }
            this.isLogin = false;
          })
        })
        this.isLogin = false;
      }
    }
  }
</script>

<style lang="less" scoped>
  .timeButton {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #efeded;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #333333;
  }

  .timeButtonClick {
    border-radius: 3px;
    cursor: pointer;
    white-space: nowrap;
    padding: 10px 20px;
    border: 0px solid #000;
    width: 94px;
    height: 24px;
    float: right;
    background-color: #1c50a7;
    font-size: 14px;
    font-weight: 400;
    font-family: Noto Sans S Chinese !important;
    line-height: 1.7;
    text-align: center;
    color: #ffffff;
  }

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266 !important;
  }

  .closes {
    background-image: url("../assets/closeone.png");
    background-size: 32px;
    height: 32px;
    width: 32px;
  }

  .closes:hover {
    background-image: url("../assets/closetwo.png");
  }

  /deep/ .el-input__inner {
    height: 44px !important;
    font-size: 16px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }

  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #fbafaf !important;
  }

  /deep/ .el-form-item__error {
    font-size: 14px;
    color: rgba(223, 37, 37, 1);
  }

  /deep/ .el-form-item {
    margin-bottom: 21px;
  }

  .login_container {
    height: 0;
    width: 0;
    background-color: #feffff;
  }

  .login_box {
    width: 615px;
    height: 501px;
    background-color: white;
    border-radius: 3px;
    position: absolute;
    left: 35%;
    box-shadow: 0 0 10px #dddddd;

    .image_box {
      position: absolute;
      transform: translate(-100%);
      border-radius: 3px;
      box-shadow: 0 0 1px #dddddd;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .login_button {
      font-family: Noto Sans S Chinese !important;

      .el-button {
        font-family: Noto Sans S Chinese !important;
        position: absolute;
        width: 100%;
        background-color: #1c4fa8;
        height: 48px;
        font-size: 20px;
      }
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #1c4fa8;
    }

    .login_form {
      .header {
        font-size: 24px;
        text-align: center;
        width: 100% !important;

        h3 {
          margin: 0;
          font-size: 24px;
          font-family: Noto Sans S Chinese !important;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }

      width: 100%;
      position: absolute;
      padding-left: 15.448%;
      padding-right: 15.448%;
      padding-top: 15px;
      box-sizing: border-box;
    }
  }
</style>
<style lang="less" scoped>
@media (max-width: 768px) {
  .login_container {
    width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 100vh;
    padding: 16px;
    overflow-x: hidden;
    background: #f3f7fb;
    box-sizing: border-box;
  }

  .login_box {
    position: relative !important;
    left: auto !important;
    width: 100% !important;
    max-width: 520px;
    height: auto !important;
    min-height: calc(100vh - 32px);
    margin: 0 auto;
    padding: 18px 16px 28px;
    border-radius: 14px;
    box-sizing: border-box;
  }

  .image_box {
    display: none;
  }

  .closes {
    display: none;
  }

  .header {
    width: 100% !important;
    margin: 0 0 16px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: none !important;
    font-size: 18px !important;
  }

  .header span,
  .header h3 {
    font-size: 18px !important;
  }

  .login_form {
    position: relative !important;
    width: 100% !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .login_form /deep/ .el-form-item,
  .login_form /deep/ .el-input {
    width: 100% !important;
    box-sizing: border-box;
  }

  .login_form /deep/ .el-input[style*="279.8px"] {
    width: calc(100% - 122px) !important;
  }

  .login_form img[aria-label="刷新图形验证码"] {
    width: 114px !important;
    object-fit: cover;
  }

  .timeButton,
  .timeButtonClick {
    width: 114px !important;
    padding: 0 4px !important;
    font-size: 12px !important;
    text-align: center;
  }

  .login_button /deep/ .el-button {
    position: static !important;
    width: 100% !important;
    height: 44px !important;
    font-size: 16px !important;
  }
}
</style>
